{
  "login": {
    "twoFactorAuthentication": "Two-factor authentication",
    "enterCodeFromAuthApp": "Please enter the six-digit code from the authenticator app on your phone.",
    "authenticationCode": "Authentication code",
    "lostAccessHint": "Lost access to your device? Enter an 8-digit recovery code or contact support.",
    "invalidCode": "Invalid code, please try again.",
    "next": "Next",
    "tooManyFailedAttempts": "Too many failed attempts, please try again later."
  },
  "errors": {
    "passwordRequired": "Password is required",
    "invalidCode": "Invalid code",
    "invalidPassword": "Invalid password",
    "unableToActivate": "Unable to activate OTP",
    "unableToDisable": "Unable to disable OTP",
    "unableToSetup": "Unable to setup OTP",
    "unableToGetUserDetails": "Unable to get user details",
    "unableToValidatePassword": "Unable to validate password",
    "alreadyEnabled": "OTP already enabled"
  },
  "prefs": {
    "userPrefsLabel": "Two-factor auth",
    "twoFactorAuthentication": "Two-factor authentication",
    "userPrefsDescription": "Two-factor authentication (2FA) adds an extra layer of security. With 2FA you log in with your username and password, and then also provide another form of authentication (typically a six-digit code) that only you have access to.",
    "userPrefsLogdnaOnly": "We support 2FA only for $t(common:companyName) logins. For Google, GitHub, or Heroku, please set up two-factor authentication via their platform.",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "enable": "Enable",
    "disable": "Disable",
    "confirm": "Confirm",
    "next": "Next",
    "setupCallout": "You have successfully set up two-factor authentication",
    "disabledCallout": "You have successfully disabled two-factor authentication",
    "defaultError": "Unable to fetch settings at the moment",
    "enterPasswordToDisable": "Enter your password to disable",
    "recoveryCodes": {
      "title": "Recovery Codes",
      "description": "If you cannot access your authenticator app, and you have a recovery code saved somewhere, you can use the recovery code instead of the auth code.",
      "show": "Show recovery codes",
      "passwordConfirm": "Enter your password to show recovery codes"
    },
    "setup": {
      "introduction": {
        "title": "Overview",
        "description": "Review the following steps for using two-factor authentication.",
        "step1Title": "Log into $t(common:companyName)",
        "step1Description": "When you log into $t(common:companyName), enter your user name and password like you used to do.",
        "step2Title": "Obtain auth code",
        "step2Description": "Open your authenticator app to obtain a code.",
        "step3Title": "Enter auth code",
        "step3Description": "In the $t(common:companyName) login screen, enter the code from your authenticator app."
      },
      "recoveryCodes": {
        "title": "Recovery Codes",
        "storeRecoveryCodes": "Store your recovery codes",
        "description": "Save your recovery codes in a safe place. Use a recovery code to log into your account if you cannot access your 2FA authenticator app. Each code can only be used once.",
        "downloadOrCopyToContinue": "Download or copy your recovery code to continue.",
        "download": "Download",
        "copy": "Copy",
        "copied": "Copied"
      },
      "configure": {
        "title": "Configure",
        "setUpViaThirdPartyApp": "Set up via third-party authenticator",
        "useAppToScanBarcode": "Please use your authentication app (e.g., Google, Okta) to scan the barcode.",
        "otherwiseUse": "Alternatively, use",
        "secretKey": "secret key",
        "toSetUpManually": "to configure authenticator manually",
        "enterTheCode": "Enter the code:"
      }
    }
  }
}
